import PropTypes from 'prop-types';

export const commoners = PropTypes.arrayOf(PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  email: PropTypes.string,
  last_name: PropTypes.string,
  place: PropTypes.string,
  position: PropTypes.string,
}));